import React from 'react';
import { Building2, Users, CreditCard, Trash2, ChevronRight, Calendar, Mail } from 'lucide-react';

const TenantList = ({ tenants, onSelect, onDelete }) => {
  const getLicenseBadgeClass = (licenseType) => {
    switch (licenseType) {
      case 'enterprise':
        return 'license-badge-enterprise';
      case 'professional':
        return 'license-badge-professional';
      default:
        return 'license-badge-free';
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'active':
        return 'status-badge-active';
      case 'suspended':
        return 'status-badge-suspended';
      case 'trial':
        return 'status-badge-trial';
      default:
        return '';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (!tenants || tenants.length === 0) {
    return (
      <div className="admin-empty-state">
        <Building2 size={48} color="#a0aec0" />
        <h3>No tenants found</h3>
        <p>Create your first tenant to get started.</p>
      </div>
    );
  }

  return (
    <div className="tenant-list">
      {tenants.map((tenant) => (
        <div
          key={tenant.id}
          className="tenant-card"
          onClick={() => onSelect(tenant)}
        >
          <div className="tenant-card-header">
            <div className="tenant-card-title">
              <Building2 size={20} color="#667eea" />
              <h3>{tenant.name}</h3>
              <span className={`status-badge ${getStatusBadgeClass(tenant.status)}`}>
                {tenant.status}
              </span>
            </div>
            <div className="tenant-card-actions">
              <button
                className="tenant-action-btn tenant-action-delete"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(tenant.id);
                }}
                title="Suspend tenant"
              >
                <Trash2 size={16} />
              </button>
              <ChevronRight size={20} className="tenant-card-chevron" />
            </div>
          </div>

          <div className="tenant-card-body">
            <div className="tenant-card-info">
              <div className="tenant-info-item">
                <span className="tenant-info-label">Slug</span>
                <span className="tenant-info-value tenant-slug">{tenant.slug}</span>
              </div>
              {tenant.billing_email && (
                <div className="tenant-info-item">
                  <Mail size={14} />
                  <span className="tenant-info-value">{tenant.billing_email}</span>
                </div>
              )}
              <div className="tenant-info-item">
                <Calendar size={14} />
                <span className="tenant-info-value">Created {formatDate(tenant.created_at)}</span>
              </div>
            </div>

            <div className="tenant-card-stats">
              <div className="tenant-stat">
                <Users size={16} />
                <span>{tenant.user_count || 0}</span>
                <span className="tenant-stat-label">users</span>
              </div>
              <div className="tenant-stat">
                <CreditCard size={16} />
                {tenant.active_license ? (
                  <span className={`license-badge ${getLicenseBadgeClass(tenant.active_license.license_type)}`}>
                    {tenant.active_license.license_type}
                  </span>
                ) : (
                  <span className="license-badge license-badge-none">No License</span>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TenantList;
